import { Routes, Route, useLocation } from 'react-router-dom';
import { Divider } from '@mui/material';

import {
  ProtectedRoute,
  CustomerRoute,
  ProviderRoute,
  AdminRoute,
  GuestRoute,
} from './ProtectedRoute';
import { ROUTES } from './routes';

import HomePage from 'pages/home/components/homepage/Homepage';
import Login from 'pages/login/components/Login';
import SignUp from 'pages/signup';
import CustomerDashboard from 'pages/dashboard/customer/components/Dashboard';
import ProviderDashboard from 'pages/provider/dashboard/ProviderDashboard';
import { DeliveryFlowPage } from 'pages/create-delivery-task';
import About from 'pages/about/components/About';
import AccountSettingsPage from 'pages/account/settings/AccountSettingsPage';
import Contact from 'pages/contact/components/Contact';
import PrivacyPolicy from 'pages/privacy-policy';
import TermsOfService from 'pages/terms-of-service';
import PageNotFound from 'pages/page-not-found';
import NavBar from 'shared/components/layout/navbar/NavBar';
import Footer from 'shared/components/layout/footer/Footer';
import OrderTracking from 'pages/tracking/OrderTracking';
import ActiveDelivery from 'pages/provider/deliveries/ActiveDelivery';
import AdminUsers from 'pages/admin/users/AdminUsers';
import AdminUserDetail from 'pages/admin/users/AdminUserDetail';
import Unauthorized from 'pages/unauthorized/Unauthorized';
import RolePage from 'pages/account/role/RolePage';
import ProviderSetup from 'pages/onboarding/ProviderSetup';
import VehicleVerify from 'pages/onboarding/VehicleVerify';
import DriverLicence from 'pages/onboarding/DriverLicence';
import AcceptInvitation from 'pages/invitations/AcceptInvitation';
import ProviderOrgAdmin from 'pages/provider/org/ProviderOrgAdmin';
import OrgDriverLicences from 'pages/provider/org/OrgDriverLicences';
import AdminVehicleReview from 'pages/admin/vehicles/AdminVehicleReview';
import AdminDriverReview from 'pages/admin/drivers/AdminDriverReview';
function AppRouter() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isLoginPage = location.pathname === '/login';
  const isSignupPage = location.pathname === '/signup';
  const isCustomerDashboard = location.pathname.startsWith('/customer');
  const isProviderApp =
    location.pathname.startsWith('/provider') || location.pathname.startsWith('/onboarding');
  const isDeliveryPage = location.pathname === '/deliverypage';
  const isAdminPage = location.pathname.startsWith('/admin');
  const isUnauthorizedPage = location.pathname === '/401';
  const isRolePage = location.pathname === '/account/role';
  const isAccountPage = location.pathname.startsWith('/account');
  const showDefaultChrome =
    !isHomePage &&
    !isLoginPage &&
    !isSignupPage &&
    !isCustomerDashboard &&
    !isProviderApp &&
    !isDeliveryPage &&
    !isAdminPage &&
    !isUnauthorizedPage &&
    !isRolePage &&
    !isAccountPage;

  return (
    <>
      {showDefaultChrome && (
        <>
          <NavBar />
          <Divider />
        </>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
        <Route path="/signup" element={<GuestRoute><SignUp /></GuestRoute>} />
        <Route path={ROUTES.INVITE.ACCEPT} element={<AcceptInvitation />} />

        {/* Customer */}
        <Route path="/customer/dashboard" element={<CustomerRoute><CustomerDashboard /></CustomerRoute>} />
        <Route path="/customer/orders/:id" element={<CustomerRoute><OrderTracking /></CustomerRoute>} />
        <Route path="/deliverypage" element={<CustomerRoute><DeliveryFlowPage /></CustomerRoute>} />

        {/* Provider onboarding */}
        <Route path={ROUTES.ONBOARDING.SETUP} element={<ProviderRoute><ProviderSetup /></ProviderRoute>} />
        <Route
          path="/onboarding/vehicle/:vehicleId/verify"
          element={<ProviderRoute><VehicleVerify /></ProviderRoute>}
        />
        <Route path={ROUTES.ONBOARDING.LICENCE} element={<ProviderRoute><DriverLicence /></ProviderRoute>} />

        {/* Provider app */}
        <Route path="/provider/dashboard" element={<ProviderRoute><ProviderDashboard /></ProviderRoute>} />
        <Route path={ROUTES.PROVIDER.ORG_ADMIN} element={<ProviderRoute><ProviderOrgAdmin /></ProviderRoute>} />
        <Route
          path="/provider/org/drivers/:userId/licences"
          element={<ProviderRoute><OrgDriverLicences /></ProviderRoute>}
        />
        <Route path="/provider/deliveries/active" element={<ProviderRoute><ActiveDelivery /></ProviderRoute>} />

        {/* Admin */}
        <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route
          path="/admin/users/:userId"
          element={<AdminRoute><AdminUserDetail /></AdminRoute>}
        />
        <Route path={ROUTES.ADMIN.VEHICLES} element={<AdminRoute><AdminVehicleReview /></AdminRoute>} />
        <Route path={ROUTES.ADMIN.DRIVERS} element={<AdminRoute><AdminDriverReview /></AdminRoute>} />

        {/* Account */}
        <Route path="/account" element={<ProtectedRoute><AccountSettingsPage /></ProtectedRoute>} />
        <Route path="/account/role" element={<ProtectedRoute><RolePage /></ProtectedRoute>} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/401" element={<Unauthorized />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {showDefaultChrome && <Footer />}
    </>
  );
}

export default AppRouter;
